
// Init Print 
gServiceUrlList = sessionStorage.getItem("veritracksservice");
